/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export const LegalPpPage: React.FC = () => (
  <div
    css={css`
      background-color: #ffffff;
      margin: 60px 20px;
      font-size: 1.3em;
    `}
  >
    <h1>Privacy Policy</h1>
    <p>
      Please read our privacy policy carefully, as it contains essential information about your
      rights and obligations. By accessing this website or using the services provided here, you
      automatically accept our privacy policy.
    </p>
    <p>Last updated: May 18, 2022</p>
    <h2>Introduction</h2>
    <p>
      This privacy notice discloses the privacy practices for our website and Applications (Apps).
      This privacy notice tells you about:
    </p>
    <ul>
      <li>
        What personally identifiable information is collected from you through the site, how we used
        them, and with whom we may share.
      </li>
      <li>What options are available to you regarding the use of your data.</li>
      <li>The security procedures in place to protect the misuse of your information.</li>
      <li>How you can correct any inaccuracies in the information.</li>
      <li><b>How you may request that the data be deleted.</b></li>
    </ul>
    <h2>Collection, use and sharing of information</h2>
    <p>We are the sole owners of the information collected on this site.</p>
    <p>We only have access to and collect information that you voluntarily provide to us.</p>
    <p>We will not sell or rent this information to anyone.</p>
    <p>We will use your information to respond to you as to why you contacted us.</p>
    <p>
      We will not share your information with third parties outside our organization{' '}
      <strong>except when necessary, to fulfil your request.</strong>
    </p>
    <p>
      Unless you ask us not to do so, <strong>we may contact you via email</strong> in the future to
      advise you of promotions, new products or services, or changes to this Privacy Policy.
    </p>
    <h2>For legal reasons</h2>
    <p>
      We will share personal information with companies, organizations or individuals if we believe
      in good faith that access, use, preservation or disclosure of the data is reasonably necessary
      to:
    </p>
    <ul>
      <li>
        Comply with any applicable legislation, regulation, formal process, or governmental request.
      </li>
      <li>
        Comply with applicable Terms of Service, including investigation of possible violations.
      </li>
      <li>Detect, prevent or otherwise address fraud, technical or security issues.</li>
    </ul>
    <h2>Your access, control over information, and data deletion</h2>
    <p>
      You may choose to cancel any future contact at any time, as long as you send us a{' '}
      <strong>notification</strong> by email, phone, or options available on our site.
    </p>
    <p>You can order what data we have about you if any.</p>
    <p>You can request change or correction of data we have about you.</p>
    <p>You can request the removal of all the data we have about you.</p>
    <p>You can notify us of any concerns you have about our use of your data.</p>
    <p>You may request that the <b>data be deleted</b> by sending an email to dorival.pedroso AT gmail DOT com</p>
    <h2>Safety</h2>
    <p>We take precautions to protect your information.</p>
    <p>
      When you submit sensitive information through the site, your information is protected online
      and offline.
    </p>
    <p>
      Wherever we collect sensitive information (such as credit card data), this information is
      encrypted and securely transmitted.
    </p>
    <p>
      You can check this secure transmission through the padlock icon in the address bar and
      observing the word <strong>HTTPS</strong> at the beginning of the web page address.
    </p>
    <p>
      While we use encryption to protect confidential information transmitted online, we also
      protect your information offline.
    </p>
    <p>
      Only employees who need the information to perform a specific job (for example, billing or
      customer service) have access to personally identifiable information.
    </p>
    <p>
      We keep the computers and servers on which we store identifiable information in a secure
      environment.
    </p>
    <p>
      <strong>
        IF YOU THINK WE ARE NOT FULFILLING THIS PRIVACY POLICY, YOU MUST CONTACT US IMMEDIATELY BY
        PHONE OR E-MAIL.
      </strong>
    </p>
    <h2>About these conditions</h2>
    <p>
      We may modify our privacy policy, for example, to reflect changes in the law or changes in how
      we operate.
    </p>
    <p>You should review our privacy policy regularly.</p>
    <p>We will post notices of modifications on our news platforms.</p>
  </div>
);
